export const GRID_DAYS_MIN = 28 // default when no data
export const GRID_DAYS_MAX = 365

// First day that appears in the schedule list (visit, instrument, or cycle start/end); only days >= 1
export const getFirstScheduleContentDay = (scheduledItems = [], cycleRanges = []) => {
  const days = new Set()
  scheduledItems.forEach(item => {
    if ((item.type === 'visit' || item.type === 'instrument') && item.studyDay != null && item.studyDay >= 1) {
      days.add(item.studyDay)
    }
  })
  cycleRanges.forEach(range => {
    if (range.startDay != null && range.startDay >= 1) days.add(range.startDay)
    if (range.endDay != null && range.endDay >= 1) days.add(range.endDay)
  })
  if (days.size === 0) return null
  return Math.min(...days)
}

// Convert study duration from list to total days (payload has study_duration only; treated as days)
export const studyDurationFromListToDays = (studyDurationFromList = null) => {
  if (!studyDurationFromList || studyDurationFromList.study_duration == null) return null
  const n = Number(studyDurationFromList.study_duration)
  if (!Number.isFinite(n) || n < 1) return null
  return Math.floor(n)
}

// Number of days for the overview grid from actual schedule (visits, instruments, cycles); ignore negative days
// When study has fewer than 28 days, show exact days (no lower cap).
// minDaysFromList: study_duration from studies list – used as floor and cap so grid never exceeds study duration
export const getGridDayCount = (scheduledItems = [], cycleRanges = [], minDaysFromList = null) => {
  let maxDay = 0
  scheduledItems.forEach(item => {
    const d = item.studyDay
    if (d != null && d >= 1 && d > maxDay) maxDay = d
  })
  cycleRanges.forEach(range => {
    const d = range.endDay
    if (d != null && d >= 1 && d > maxDay) maxDay = d
  })
  if (minDaysFromList != null && minDaysFromList > 0) {
    if (maxDay < minDaysFromList) maxDay = minDaysFromList
    return Math.min(maxDay, minDaysFromList)
  }
  if (maxDay < 1) return GRID_DAYS_MIN
  return Math.min(GRID_DAYS_MAX, maxDay)
}
